import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { take } from 'rxjs';

import { IFilterNumber } from '@shared/models/graphql';

import { Store } from '@ngrx/store';
import { AppState } from '@state/app.state';
import { setUnsavedLotSizeFiltersAction } from '@state/filters/filters.actions';
import { selectFiltersCurrent } from '@state/filters/filters.selectors';

@UntilDestroy()
@Component({
  selector: 'app-filter-v2-lot-size',
  templateUrl: './filter-v2-lot-size.component.html',
  styleUrls: [
    './filter-v2-lot-size.component.scss',
    '../filters-v2.component.scss',
  ],
})
export class FilterV2LotSizeComponent implements OnInit {
  public minValue = 0;
  public maxValue = 0;
  protected options = [
    1000, 2000, 3000, 4000, 5000, 7500, 10000, 20000, 40000, 80000, 200000,
    400000, 1000000, 2000000, 4000000,
  ];

  constructor(private store: Store<AppState>) {}

  ngOnInit(): void {
    this.loadInitialValue();

    // for clearing the filters
    this.store
      .select(selectFiltersCurrent)
      .pipe(untilDestroyed(this))
      .subscribe((filters) => {
        if (
          !filters?.lotSize ||
          (!filters.lotSize.greaterThanOrEqual &&
            !filters.lotSize.lessThanOrEqual)
        ) {
          this.minValue = 0;
          this.maxValue = 0;
        }
      });
  }

  handleChange() {
    if (this.minValue > this.maxValue && this.maxValue > 0) {
      this.maxValue = this.minValue;
    }

    let lotSizeQuery: IFilterNumber = {};
    if (this.minValue > 0) {
      lotSizeQuery.greaterThanOrEqual = this.minValue;
    }
    if (this.maxValue > 0) {
      lotSizeQuery.lessThanOrEqual = this.maxValue;
    }

    this.store.dispatch(setUnsavedLotSizeFiltersAction(lotSizeQuery));
  }

  loadInitialValue() {
    this.store
      .select(selectFiltersCurrent)
      .pipe(take(1))
      .subscribe((filters) => {
        if (filters?.lotSize) {
          if (filters.lotSize.greaterThanOrEqual) {
            this.minValue = filters.lotSize.greaterThanOrEqual;
          } else {
            this.minValue = 0;
          }
          if (filters.lotSize.lessThanOrEqual) {
            this.maxValue = filters.lotSize.lessThanOrEqual;
          } else {
            this.maxValue = 0;
          }
        } else {
          this.minValue = 0;
          this.maxValue = 0;
        }
      });
  }
}
